import { render } from "./query.vue?vue&type=template&id=4a71e94f&scoped=true"
import script from "./query.vue?vue&type=script&lang=js"
export * from "./query.vue?vue&type=script&lang=js"

import "./query.vue?vue&type=style&index=0&id=4a71e94f&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a71e94f"]])

export default __exports__